<template>
	<div
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
			getWrapperClass(node),
		]"
		:style="getWrapperStyle(node)"
		@click="onNodeClick(node)"
	>
		<NodeAction
			:node="node"
			component="element"
			v-if="!onPreview"
		/>

		<!-- page -->
		<order-form
			:node="node"
			:key="componentKey"
			:previewDevice="previewDevice"
			v-if="isPage"
		/>

		<!-- popup -->
		<button
			:class="[
				'd-flex align-items-center',
				getButtonClass(node),
			]"
			:style="getButtonStyle(node)"
			v-if="isPopup">
			<template v-if="node.options.buttonIconKey && node.options.buttonIconKey !== '' && node.options.buttonIconPosition === 'before'">
				<i :style="getIconStyle(node, 'before')" :class="getIcon(node)"></i>
			</template>
			<div class="mx-auto">
				<node-editor
					:key="node.key"
					v-model="node.options.popupAction"
					@focus="onNodeClick(node)"
				/>
			</div>
			<template v-if="node.options.buttonIconKey && node.options.buttonIconKey !== '' && node.options.buttonIconPosition === 'after'">
				<i :style="getIconStyle(node, 'after')" :class="getIcon(node)"></i>
			</template>
			<!-- <i
				:style="getIconStyle(node, 'before')"
				:class="getIcon(node)"
				v-if="isHasIcon && iconPosition === 'before'">
			</i>
			<span>
				<node-editor
					:key="node.key"
					v-model="node.options.popupAction"
					@focus="onNodeClick(node)"
				/>
			</span>
			<i
				:style="getIconStyle(node, 'after')"
				:class="getIcon(node)"
				v-if="isHasIcon && iconPosition === 'after'">
			</i> -->
		</button>
	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import OrderForm from '@/components/funnels/pagebuilder/form/Form.vue';
import {
	getNodeStyle,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeForm',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		NodeEditor,
		OrderForm,
	},
	data() {
		return {
			isReady: false,
			componentKey: 0,
		};
	},
	watch: {
		node: {
			deep: true,
			handler() {
				this.componentKey += 1;
			},
		},
	},
	methods: {
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
		getWrapperStyle({ options }) {
			// Temp Remove Green Background Color
			if (options.backgroundColor && options.backgroundColor.rgb) {
				const rgb = options.backgroundColor.rgb;
				const isGreen = rgb.r === 48 && rgb.g === 198 && rgb.b === 75;
				if (isGreen) {
					const whiteColor = {
						a: 1,
						r: 255,
						g: 255,
						b: 255,
					};
					options.backgroundColor.rgb = whiteColor;
				}
			}

			const device = this.previewDevice;
			const styles = [];
			if (options.mode === 'popup') {
				styles.push('margin');
				styles.push('padding');
			}
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getButtonStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'button-padding',
				'button-font-size',
				'button-color',
				'button-bg-color',
				'button-font-family',
				'button-border',
				'box-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperClass({ options }) {
			let pClass = '';
			if (this.isPopup) {
				if (options && options.align) {
					pClass += ` text-${options.align}`;
					pClass += ' d-flex';
					let justify = 'center';
					if (options.align === 'left') {
						justify = 'start';
					} else if (options.align === 'right') {
						justify = 'end';
					}
					pClass += ` justify-content-${justify}`;
				}
			}
			return pClass;
		},
		getButtonClass(node) {
			let pClass = `btn ${node.class || ''}`;

			const { options } = node;
			if (options && options.style && options.style === 'block') {
				pClass += ' btn-block';
			}

			if (options.style === 'block') {
				let justify = 'center';
				if (options.align === 'left') {
					justify = 'start';
				} else if (options.align === 'right') {
					justify = 'end';
				}
				pClass += ` justify-content-${justify}`;
			}

			return pClass;
		},
		getIcon(node) {
			const icon = `${node.options.buttonIconStyle} fa-${node.options.buttonIconKey}`;
			return icon;
		},
		getIconStyle(node, position) {
			let style = '';
			if (node && node.options && node.options.buttonIconSpacing && position === 'before') {
				style = `margin-right: ${node.options.buttonIconSpacing}px`;
			} else if (node && node.options && node.options.buttonIconSpacing && position === 'after') {
				style = `margin-left: ${node.options.buttonIconSpacing}px`;
			}
			return style;
		},
	},
	computed: {
		isPage() {
			return this?.node?.options?.mode === 'page';
		},
		isPopup() {
			return this?.node?.options?.mode === 'popup';
		},
		isHasIcon() {
			return this.node.options.iconKey && this.node.options.iconKey !== '';
		},
		iconPosition() {
			return this?.node?.options?.iconPosition ?? 'before';
		},
	},
};
</script>

<style scoped>
.wrapper {
	background-color: #fafafa;
	text-align: center;
	padding: 20px 0;
}

.wrapper h3 {
	margin: 0;
}
</style>
